import { Injectable } from '@angular/core';
import { PortalFieldConfig } from '@portal/form/data-access';
import { MarketingConsentModelKeys } from '../const/form-field-key.const';

@Injectable({ providedIn: 'root' })
export class MarketingConsentFormConfigService {
  initMarketingConsentFormFields(): PortalFieldConfig[] {
    return [
      {
        key: MarketingConsentModelKeys.isEAdvice,
        type: 'checkbox-boolean',
        props: { labelCheckbox: 'Voice call/phone call' },
      },
      {
        key: MarketingConsentModelKeys.isContactSMS,
        type: 'checkbox-boolean',
        props: { labelCheckbox: 'SMS/MMS/WhatsApp/Other messaging platform (text message)' },
      },
      {
        key: MarketingConsentModelKeys.isFax,
        type: 'checkbox-boolean',
        props: { labelCheckbox: 'Fax' },
      },
      {
        template:
          '<div><span class="font-bold">Note: </span>Please indicate your consent to the above, and preference for the mode of communication, by checking in the applicable box(es) above.</div>',
      },
      {
        template:
          '<div class="mt-4">In the event that no indication is made on the above, CIMB reserves its right to send Marketing Messages to your Singapore telephone number registered with CIMB (“Registered Number”) if you have an ongoing relationship with CIMB or if the Registered Number is not registered with the National Do Not Call Registry.</div>',
      },
    ];
  }
}
